import type { TranscriptLine } from "shared/components/CallTranscript";

// The API rebuilds a word-aligned line with single spaces (CRM-1561), so the
// stored quote and the rendered line can differ in whitespace only.
const normalizeSpaces = (value: string) => value.trim().split(/\s+/).join(" ");

// The caller line the follow-up quote was copied from (CRM-1872). The quote is
// verbatim caller speech, so only caller lines are searched. Null when there is
// no quote or no line holds it.
export const findCallerQuoteLine = (
  lines: TranscriptLine[],
  quote: string | null | undefined
): number | null => {
  const needle = quote ? normalizeSpaces(quote) : "";
  if (!needle) return null;

  const index = lines.findIndex(
    (line) =>
      line.speaker.toLowerCase() !== "agent" &&
      normalizeSpaces(line.message).includes(needle)
  );
  return index === -1 ? null : index;
};

// “Would they both be allowed?”, or null when there is no quote.
export const formatCallerQuote = (
  quote: string | null | undefined
): string | null => {
  const text = quote?.trim();
  return text ? `“${text}”` : null;
};
